import axios from 'axios';
const BASE_URL = process.env.REACT_APP_API_URL;

export const init = () => {
    console.log('Axios.interceptor:init()');

    axios.defaults.baseURL = `${BASE_URL}`;
    // axios.defaults.headers.common['Access-Key'] = process.env.REACT_APP_API_ACCESS_KEY;

    axios.interceptors.request.use(config => {
        return config;
    });

    // axios.interceptors.
}